import React from "react";
import Modal from "react-modal";
import { Icon } from "@mdi/react";
import { mdiClose, mdiOpenInNew } from "@mdi/js";
import { useTranslation } from "react-i18next";

export default function VideoProcessingModal({ isOpen, assetId, onClose }) {
    const { t } = useTranslation();

    if (!assetId) return null;

    const videoUrl = `https://my3.icareus.com/media-library/assets/video/${assetId}`;
    const processingUrl = "https://my3.icareus.com/media-library/transcoding";

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel={t("dashboard.videoProcessingTitle")}
            className="modalTitle"
            overlayClassName="overlay"
        >
            <div className="title-inputPrimary" style={{ textAlign: "center" }}>
                <div className="title-input">
                    <div className="title-input__label display-flex-center">

                        {t("dashboard.videoProcessingTitle")}
                    </div>

                    <div className="title-input__input">
                        <p style={{ marginTop: "15px" }}>
                            {t("dashboard.videoProcessingMessage")}
                        </p>

                        {/* Video link */}
                        <div style={{ marginTop: "12px" }}>
                            <strong>{t("dashboard.videoLink")}</strong>
                            <p>
                                <a
                                    href={videoUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link underline text-blue-600"
                                >
                                    {videoUrl} <Icon path={mdiOpenInNew} size={0.8} />
                                </a>
                            </p>
                        </div>

                        {/* Processing link */}
                        <div style={{ marginTop: "12px" }}>
                            <strong>{t("dashboard.processingStatusLink")}</strong>
                            <p>
                                <a
                                    href={processingUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link underline text-blue-600"
                                >
                                    {processingUrl} <Icon path={mdiOpenInNew} size={0.8} />
                                </a>
                            </p>
                        </div>
                    </div>
                </div>

                <div className="button" style={{ marginTop: "20px" }}>
                    <button
                        className="button-title"
                        onClick={onClose}
                        style={{ background: "#0A7AAD" }}
                    >
                        <Icon path={mdiClose} size={1} color="white" style={{ marginLeft: "8px" }} />
                        {t("shared.close")}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
